import { Component, OnInit } from "@angular/core";
import { environment } from "src/environments/environment";
declare var $: any;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit {
  public title = "OnstakSCMLayout";

  public favIcon: HTMLLinkElement = document.querySelector("#appIcon");
  public mainTitle: HTMLLinkElement = document.querySelector("#appTitle");

  ngOnInit() {
    this.favIconUpdate();
  }

  favIconUpdate() {
    //change the favicon based on local storage if not saved load the onstak befor logged in
    let savedTenantId = localStorage.getItem(
      environment.ProjectName + "_tenantId",
    );
    if (Number(savedTenantId) > 0) {
      this.favIcon.href =
        environment.IDENTITY + "/cdn/tenants/logo/" + savedTenantId + ".x-icon";
    } else {
      this.favIcon.href =
        environment.IDENTITY + "/cdn/tenants/logo/" + 2 + ".x-icon";
    }
    //change the app title based on local storage if not saved load the onstak
    let savedTitle = localStorage.getItem(
      environment.ProjectName + "_titleName",
    );
    //
    if (savedTitle == null) {
      this.mainTitle.innerText = "Onstak-Video-AI";
    } else {
      this.mainTitle.innerText = savedTitle;
    }
  }
}
